import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Title, Meta } from '@angular/platform-browser';

import { TipsService } from './tips.service';

@Component({
  selector: 'app-tips',
  templateUrl: './tips.component.html',
  styleUrls: ['./tips.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class TipsComponent implements OnInit, OnDestroy {

	private inscription: Subscription;
	public data: any = {
		'image' : '',
		'seoDescription' : '',
		'seoTitle' : '',
		'shortDescription' : '',
		'text' : '',
		'title' : '',
	};

	constructor(private _service: TipsService, private _titleService: Title, private _meta: Meta) {
		this._titleService.setTitle( 'Dicas e Informações - Hospital Veterinário Stolf');
		this._meta.addTag({
			name: 'title',
			content: 'Dicas Para Cuidar Do Seu Pet - Hospital Veterinário Stolf'
		});
		this._meta.addTag({
			name: 'description',
			content: 'Aqui você encontra dicas e informações sobre cuidados, comportamento e curiosidades sobre seu cão ou gato, para que você possa cuidar e dar o tratamento que ele merece'
		});
	}

	ngOnInit() {
		this.inscription = this._service.listAll()
		.subscribe(
			response => {
				this.data['itens'] = response;
			},
			error => {
				console.error ( error );
			}
		);
	}


	formatDate(date) {
		let meses = [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro'
		  ];
		let str = date.substr(0, 10).split('-').reverse().join('/');
		let dias = ['domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
		let partes = str.split('/').map(Number);
		let data = new Date( partes[2], partes[1] - 1, partes[0]);
		let diaSemana = dias[data.getDay() % 7];
		let mes = meses[data.getMonth()];
		let ano = partes[2];
		return [data.getDate() + ' de ' + mes.toLowerCase() + ' de ' + ano].join(' ');
	  }

	  ngOnDestroy() {
		this.inscription.unsubscribe();
	}

}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/tips/tips.component.ts